// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HwXNt","rootNoMargin":"styles_rootNoMargin__2JiZ6"};